/**
 * Route definitions for the print assets section (files list, file detail).
 * Mirrors the pattern in views/admin/billing/routes.tsx.
 */
import { RouteObject } from "react-router-dom";
import { withHandle } from "../../utils/route.util";
import { PrintAssetsView } from "./PrintAssetsView";
import { PrintAssetView } from "./PrintAssetView";

export const printAssetsRoutes: RouteObject[] = [
  {
    path: "print-assets",
    element: <PrintAssetsView />,
    ...withHandle("print-assets"),
  },
  {
    path: "print-assets/:id",
    element: <PrintAssetView />,
    ...withHandle("print-asset-detail"),
  },
];
